import { useFetch } from "../../../hooks/api";
import { useModuleEnabled } from "../../../redux/selectors/modules";

export const useAMCInstanceDataSouces = () => {
  const hasAMCModule = useModuleEnabled("AMC");

  const { data, isLoading } = useFetch(
    ["allowAMCDataSources"],
    "/amc/datasources",
    {},
    {
      select: (res) => {
        return res.data ?? [];
      },
      enabled: hasAMCModule,
      default: [],
    },
  );

  return { data, isLoading };
};
